<style lang="scss" scoped>
.camera {
  width: 416px;
  height: 178px;

  .plane {
    .monitordata {
      width: 100%;
      position: absolute;
      top: 66px;
      display: flex;
      padding: 0 20px;
      justify-content: space-around;

      .line_data {
        text-align: center;
        height: 92px;
        width: 100px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        font-weight: 500;
        font-size: 18px;

        // 百分比
        .bfb {
          font-family: "dina";
          font-weight: 500;
          font-size: 48px;

          span {
            font-family: "dina";
            font-size: 24px;
            margin-left: 4px;
          }
        }

        // 异常数
        .ycs {
          font-family: "dina";
          font-weight: 500;
          font-size: 48px;
          color: #f1802f;
        }
      }
    }
  }
}
</style>

<template>
  <div class="camera">
    <custom-plane
      title="监控中心"
      class="plane"
      :iconImg="require('@/assets/compImg/icon/monitor.png')"
    >
      <div class="monitordata">
        <div class="line_data">
          <p>在线率</p>
          <p class="bfb">{{ online.slice(0, -1) }}<span>%</span></p>
        </div>
        <div class="line_data">
          <p>异常数量</p>
          <p class="ycs">{{ abnormal }}</p>
        </div>
      </div>
    </custom-plane>
  </div>
</template>

<script>
import { getEqpInfo } from "@/api/index";
export default {
  data() {
    return {};
  },
  props: {
    online: String,
    abnormal: Number,
  },
  created() {
    this.ReqVideoUrl();
  },
  methods: {
    // 获取监控
    async ReqVideoUrl() {
      let res = await getEqpInfo({ monitorURL: "111" });
      // console.log(res);
    },
  },
};
</script>
